import {FlowLang} from 'flow-to-typescript-codemod';
export const getDisplayName = (
  Component: FlowLang.AbstractComponent<any>,
  componentName?: string
): string => {
  if (componentName) {
    return componentName;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return 'Component';
  }

  return Component.displayName || Component.name || 'Component';
};
